import { render, staticRenderFns } from "./bGalleryViewNew.vue?vue&type=template&id=412fa365&scoped=true"
import script from "./bGalleryViewNew.vue?vue&type=script&lang=js"
export * from "./bGalleryViewNew.vue?vue&type=script&lang=js"
import style0 from "./bGalleryViewNew.vue?vue&type=style&index=0&id=412fa365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412fa365",
  null
  
)

export default component.exports